import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

const gltfLoader = new GLTFLoader()
const dracoLoader = new DRACOLoader()
const textureLoader = new THREE.TextureLoader()

dracoLoader.setDecoderPath('/lib/draco/')
gltfLoader.setDRACOLoader(dracoLoader)

export const loadModel = (path, done) => gltfLoader.load(path, done, undefined, () => {
  console.error(`Unable to load model: ${path}`)
})

// Load a texture using THREE.TextureLoader
export const loadTexture = path => textureLoader.load(path)
